module.exports = __webpack_public_path__ + "img/ehr_system.573ea03c.jpg";